import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  btnRow: {
    columnGap: 16,
    rowGap: 16,
    marginTop: 24
  },
  button: {
    maxWidth: 264,
    padding: '14px 10px'
  },
  '@media screen and (max-width: 1152px)': {
    btnRow: {
      flexWrap: 'wrap'
    },
    button: {
      maxWidth: '100%'
    }
  }
})
